<template lang="pug">
v-dialog#customer-dialog(v-model="value", scrollable, persistent, max-width=640, eager)
  v-card 
    v-card-title 
      .title {{ $t('Customers.__AddCustomer') }}
    v-card-text
      v-form(v-model="formValid", ref="customerform")
        .field-label 
          span {{ $t('ContactInfo.__CustomerName') }}
          span.required *
        v-text-field(v-model="customer.name", solo, dense, outlined, required, :rules="[rules.required]")
        .field-label 
          span Email
          //- span.required *
        v-text-field(v-model="customer.email", solo, dense, outlined, required, :rules="[rules.email]")
        //- .notice.primary--text 顧客詳細資料請至廠商頁面更新。

    v-card-actions.justify-center.mb-6
      v-btn.mr-6(rounded, dark, @click="cancelEditDialog", color="lightGray", width="112") {{ $t('ActionOption.__Cancel') }}
      v-btn(rounded, dark, @click="saveEdit", color="primary", width="112") {{ $t('ActionOption.__Save') }}
</template>

<script>
import * as textfieldUtils from "@/utils/textfield.js"

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    doneAction: {
      type: Function,
      default: () => { }
    }
  },
  data() {
    return {
      customer: {},
      formValid: false,
      rules: textfieldUtils.rules
    }
  },
  methods: {
    saveEdit() {
      this.$refs.customerform.validate()
      if (this.formValid) {
        this.createVendor()
      }
    },
    createVendor() {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("customers/createCustomer", this.customer)
        .then(
          function (response) {
            this.savedTag = true
            this.doneAction(response.data.customerId)
            this.$store.dispatch("global/stopLoading")
            this.$store.dispatch("global/showAlertSuccess", this.$t("Messages.__SuccessfullyCreated"))
          }.bind(this)
        )
        .catch(
          function (error) {
            this.$store.dispatch("global/stopLoading")
            this.$store.dispatch("global/showAlertError", error.message)
          }.bind(this)
        )
      this.cancelEditDialog()
    },
    cancelEditDialog() {
      this.$emit("input", false)
      this.$refs.customerform.resetValidation()
      this.$refs.customerform.reset()
    }
  }
}
</script>
